import React from 'react'
import Grid from '../layout/grid'

export default props => {
    let labelFloat = null;
    let labelCol = props.labelCol ? props.labelCol : 6 ;
    let inputCol = 12 - labelCol ;
    if(props.labelFloat){
        labelFloat = props.labelFloat
    } else {
        props.orientation == 'landscape' ? 'right' : 'unset';
    }

    let labelColClasses = `col-md-${labelCol} col-sm-${labelCol} col-xs-${labelCol}`;
    let inputColClasses = `col-md-${inputCol} col-sm-${inputCol} col-xs-${inputCol}`;  
    return (
        <Grid cols={props.cols} isNoppading={ props.orientation == 'landscape' ? true : false}>
            <div className='form-group'>
                <div className={labelColClasses} style={props.orientation == 'landscape' ? {float:'left', paddingLeft:'0px'} : { padding: '0 5px 0 0'}}>
                    <label htmlFor={props.name} style={{float: props.orientation == 'landscape' ? 'right' : 'unset',  fontSize:'15px', marginTop:'10px', paddingLeft:'0'}}>{props.label}</label>
                </div>
                <div className={`${inputColClasses} nopadding`} style={{display:'flex'}}>
                    <input {...props.input} className='form-control'
                        placeholder={props.placeholder}
                        readOnly={props.readOnly} type={props.type}
                        value={props.text} />
                </div>
            </div>
        </Grid>
    ) 
} 


// WEBPACK FOOTER //
// ./src/common/form/labelAndInput.jsx